var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 5.625H13.4375L12.875 6.875H16.25V16.25H1.25V6.875H7.75L7.5625 7.25C7.375 7.6875 7.6875 8.125 8.125 8.125H10.875C11.375 8.125 11.8125 7.8125 12 7.375L15.25 0H10.75L8.75 4.5625L6.6875 0H2.25L4.5 5H5.875L4.125 1.25H5.875L7.8125 5.625H1.25C0.5625 5.625 0 6.1875 0 6.875V16.25C0 16.9375 0.5625 17.5 1.25 17.5H16.25C16.9375 17.5 17.5 16.9375 17.5 16.25V6.875C17.5 6.1875 16.9375 5.625 16.25 5.625ZM9.0625 6.875L11.5625 1.25H13.3125L10.8125 6.875H9.0625ZM15 11.25H8.75V10H15V11.25ZM8.75 13.125H15V14.375H8.75V13.125ZM6.5 12.75C6.5 12.75 6.4375 12.8125 6.4375 12.875L6.6875 14.25C6.6875 14.375 6.625 14.4375 6.5 14.375L5.25 13.75C5.1875 13.75 5.1875 13.75 5.125 13.75L3.875 14.375C3.75 14.4375 3.6875 14.375 3.6875 14.25L3.9375 12.875C3.9375 12.8125 3.9375 12.8125 3.875 12.75L2.875 11.8125C2.8125 11.75 2.8125 11.625 2.9375 11.5625L4.375 11.375C4.4375 11.375 4.4375 11.3125 4.5 11.3125L5.125 10.0625C5.1875 9.9375 5.3125 9.9375 5.375 10.0625L6 11.3125C6 11.375 6.0625 11.375 6.125 11.375L7.5 11.5625C7.625 11.5625 7.625 11.6875 7.5625 11.8125L6.5 12.75Z",
    fill: "#BFA247"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageIcon);
export default __webpack_public_path__ + "static/media/package-icon.5a262b43694aaa5858f2b76a6e769dcc.svg";
export { ForwardRef as ReactComponent };